export const WhatsappMessages = {
  generalQuestion: "Hola! Deseo conocer más sobre Bohiio.",
  priceRealStateRequestQuote:
    "Hola! Deseo solicitar una cotización para tasar un inmueble.",
  certifyRealStateRequestQuote:
    "Hola! Deseo solicitar una cotización para regularizar mi propiedad.",
  certifyRealStateInfo:
    "Hola! Deseo conocer más información sobre los servicios para regularizar mi propiedad.",
  verifyPropertyHelp: "Hola! Necesito asistencia para verificar una propiedad.",
  planServiceInformation:
    "Hola! Deseo conocer más información sobre los servicios y planes de Bohiio.",
  verificationCoupon:
    "Hola! Deseo obtener el cupón de descuento para mi primera verificación.",
  refereeInfoProgram:
    "Hola! Soy agente inmobiliario y deseo conocer más detalles del programa de referidos para generar ingresos con Bohiio.",
  agentWork:
    "Hola! Soy agente inmobiliario y deseo conocer más detalles para trabajar con Bohiio.",
  appraiserWork:
    "Hola! Soy tasador/a y deseo conocer más detalles para trabajar con Bohiio.",
  layerWork:
    "Hola! Soy abogado/a y deseo conocer más detalles para trabajar con Bohiio.",
  surveyorWork:
    "Hola! Soy agrimensor/a y deseo conocer más detalles para trabajar con Bohiio.",
  paymentsInfo:
    "Hola! Deseo conocer más información sobre las facilidades de pago para los procesos de regularización.",
  verificationPlansHighVolume:
    "Hola! Deseo conocer más información sobre los paquetes de verificaciones para altos volúmenes.",
};

export const getWsLink = (number: string, message: string): string => {
  const url = new URL("https://api.whatsapp.com/send");
  url.searchParams.append("phone", number);
  url.searchParams.append("text", message);
  return url.toString();
};
